export default __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLEj6Z1JlFc-K.29c728e1.woff2";